module.exports = __webpack_public_path__ + "static/media/Satoshi_Bold.d4db658f.woff2";